export default __webpack_public_path__ + "static/2-6-0-0-6a230920cacc478a061a2489a63190db.jpg";